import React, { useRef,useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { isEmpty } from "lodash";
import CommonInput from "../../common/component/commonInput";
import useValidation from "../../common/utils/validationRules";
import CommonButton from "../../common/component/commonButton";
import { useDispatch, useSelector } from "react-redux";
import { forgotPasswordCreate } from "../../service/action/actioncreator/LoginAction/LoginAction";
import { useLoader } from "../../common/component/LoaderProvider";
import CommonLoader from "../../common/component/commonLoader";
import { useNavigate } from "react-router-dom";
import logoImg from "../../assests/images/sifo-lofo.png";
import { useToast } from "../../common/component/Toast";
import { useTranslation } from "react-i18next";

const ForgotPassword = () => {

  const [notificationFlag, setNotificationFlag] = useState(false);
  const { showLoader, hideLoader } = useLoader();
  const buttonRef = useRef(null);
  const dispatch = useDispatch();
  const { validateField } = useValidation();
  const navigate = useNavigate();
  const { showToast } = useToast();
  const { t } = useTranslation("translation");
  const loading = useSelector(
    (state) => state.loginReducer.forgotPasswordLoading
  );
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    watch,
  } = useForm();
  watch("Email");

  const emailInviteFn = (data) => {
    if (!isEmpty(getValues("Email"))) {
      // dispatch(forgotPasswordCreate(payload,navigate,showLoader,hideLoader,showToast))
      setNotificationFlag(true);
    }
  };

  const onSubmit = (data) => {
    var payload = {
      email: getValues("Email")?.trim(),
    };
    dispatch(
      forgotPasswordCreate(payload, navigate, showLoader, hideLoader, showToast)
    );
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      buttonRef.current?.click();
    }
  };

  // Add event listener to the input
  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
  return (
    <div className="main-container otp-footer">
      <div className="login-container">
        <div className="login-box text-center">
          <div className="display-flex">
            <img src={logoImg} alt="log-img" className="logo-img" />
          </div>
          <div className="login-form">
            <div className="mb-3">
              {!notificationFlag ? (
                <CommonInput
                  name="Email"
                  placeholder={t("placeholder_email")}
                  register={register}
                  errors={errors}
                  validationFn={validateField}
                  requiredField={true}
                  inputStyle={true}
                  errorStyle={false}
                />
              ) : (
                <div className="text-center custom-text-break text-break-forgot-pw font-size-fs-6 primary-text-color">
                  Se la mail indicata risulta registrata a sistema, riceverai a
                  tale indirizzo la nuova password provvisoria che dovrai
                  cambiare alla prima Login
                </div>
              )}
            </div>
            {!notificationFlag && (
              <p className="primary-text-color text-sm w-100">
                {t("text_forgot_password_info")}
              </p>
            )}
            <div className="mt-5">
              {!notificationFlag ? (
                <>
                  <CommonButton
                    label={t("text_button_cancel")}
                    className=" btn btn-cancel btn-cancel-style input-style-common btn-width btn-padding primary-text-color"
                    variant="cancel"
                    type="button"
                    onClick={() => navigate("/")}
                    inputStyle={true}
                  />
                  <CommonButton
                    label={t("text_button_send")}
                    disabled={isEmpty(getValues("Email"))}
                    onClick={handleSubmit(onSubmit)}
                    className="ms-4 btn btn-success btn-padding btn-width input-style-common text-white"
                    type="submit"
                    variant="success"
                    inputStyle={true}
                  />
                </>
              ) : (
                <CommonButton
                  label={t("text_button_send")}
                  disabled={isEmpty(getValues("Email"))}
                  onClick={handleSubmit(onSubmit)}
                  buttonRef={buttonRef}
                  className="ms-4 btn btn-success btn-padding btn-width input-style-common text-white"
                  type="submit"
                  variant="success"
                  inputStyle={true}
                />
              )}
            </div>
            <div className="mt-5">
              <hr />
              {!notificationFlag ? (
                <div className="fw-bold w-60 text-center custom-text-break font-size-fs-3">
                  {t("text_create_new_password_link")}
                </div>
              ) : (
                <div className="fw-bold  text-center custom-text-break font-size-fs-5">
                  {"Verifica il tuo indirizzo mail"}
                </div>
              )}
            </div>
          </div>
          <CommonLoader loading={loading} />
          <div className="forgot-password"></div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
